module.exports = __webpack_public_path__ + "img/compliance.06d57f29.jpg";